/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomColumn } from 'components/DataTable/Columns/index';
// utils
import { formatNumber } from 'utils';
import { formatBackEndWeightToSystem, weightUnitLabel } from 'utils/weightHelper';
import cn from 'classnames';

const renderNameBinsColumn = ({ name, error }) => (
  <CustomColumn
    label={<FormattedMessage id="component.dataTable.headers.binID" />}
    className={cn({ 'highlighted': error === 'name' })}
  >
    {name || '-'}
  </CustomColumn>
);

// error rows keep the value as typed in the file, created rows hold lbs and are shown in the tenant unit
const renderCapacityColumn = (status, measurementSystem) => ({ capacity, error }) => {
  const isCreated = status !== 'errors' && capacity;
  const shownCapacity = Math.round(formatBackEndWeightToSystem(capacity, measurementSystem));
  const value = isCreated ? `${formatNumber(shownCapacity)} ${weightUnitLabel(measurementSystem)}` : capacity;

  return (
    <CustomColumn
      label={<FormattedMessage id="component.dataTable.headers.capacity" />}
      className={cn({ 'highlighted': error === 'capacity' })}
    >
      {value || '-'}
    </CustomColumn>
  );
};

const renderFarmColumn = ({ farm_name, error }) => (
  <CustomColumn
    label={<FormattedMessage id="component.dataTable.headers.farmName" />}
    className={cn({ 'highlighted': error === 'farm' })}
  >
    {farm_name || '-'}
  </CustomColumn>
);

const binColumns = (status, measurementSystem) => ([
  { label: <FormattedMessage id="component.dataTable.headers.binID" />, flex: '1 1 140px',
    renderer: renderNameBinsColumn, sortKey: 'name' },
  { label: <FormattedMessage id="component.dataTable.headers.capacity" />, flex: '1 1 140px',
    renderer: renderCapacityColumn(status, measurementSystem), sortKey: 'capacity' },
  { label: <FormattedMessage id="component.dataTable.headers.farmName" />, flex: '1 1 140px',
    renderer: renderFarmColumn, sortKey: 'farm_name' },
]);

export default binColumns;
